import { ALLERGENS } from "@foodlista/shared/allergens/constants"
import { z } from "zod"

export const allergenDetectInputSchema = z.object({
	productId: z.string().uuid().optional(),
	name: z.string(),
	category: z.string().optional(),
	description: z.string().optional(),
	skipIfAllergensChangedFrom: z.array(z.enum(ALLERGENS)),
})

export const allergenDetectOutputSchema = z.object({
	allergens: z.array(z.enum(ALLERGENS)),
	persistence: z.discriminatedUnion("status", [
		z.object({ status: z.literal("not-requested") }),
		z.object({ status: z.literal("applied") }),
		z.object({
			status: z.literal("skipped"),
			reason: z.literal("stale-snapshot"),
		}),
	]),
})

/**
 * Semantic phases emitted by the allergen-detect task via `ctx.progress`.
 * Frontend maps `kind` → translation key; the backend does not know locale
 * or namespaces.
 */
export type AllergenDetectProgressPhase =
	| { kind: "analyzing" }
	| { kind: "detected"; count: number }
	| { kind: "done" }

export type AllergenDetectInput = z.infer<typeof allergenDetectInputSchema>
export type AllergenDetectOutput = z.infer<typeof allergenDetectOutputSchema>
